<template>
  <div class="container-fluid">
    <div class="row" id="app">
      <!-- Inputs Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <TopbarNav />
        <hr/>
        <!-- Section 1: Climatic Data -->
        <div class="row">
          <div class="col-6">
            <input type="radio" v-model="climate_method" value="user">By User
          </div>
          <div class="col-6">
            <input type="radio" v-model="climate_method" value="location">By Location
          </div>
        </div>
        <hr/>
                
        <!-- Location Mode -->
        <div v-if="climate_method === 'location'">
          <!-- Province -->
          <div class="row">
            <div class="col-6">Province</div>
            <div class="col-6">
              <select name="province" v-model="province">
                <option value="">Select Province...</option>
                <option value="Alberta">Alberta</option>
                <option value="British Columbia">British Columbia</option>
                <option value="Manitoba">Manitoba</option>
                <option value="New Brunswick">New Brunswick</option>
                <option value="Newfoundland">Newfoundland</option>
                <option value="Northwest Territories">Northwest Territories</option>
                <option value="Nova Scotia">Nova Scotia</option>
                <option value="Nunavut">Nunavut</option>
                <option value="Ontario">Ontario</option>
                <option value="Prince Edward Island">Prince Edward Island</option>
                <option value="Quebec">Quebec</option>
                <option value="Saskatchewan">Saskatchewan</option>
                <option value="Yukon">Yukon</option>
              </select>
            </div>
          </div>
                  
          <!-- City -->
          <div class="row" v-if="province">
            <div class="col-6">City</div>
            <div class="col-6">
              <select name="city" v-model="city" class="city-select">
                <option value="">Select City...</option>
                <option v-for="(cityOption, index) in cities" :key="index" :value="cityOption.city">
                  {{ cityOption.city }}
                </option>
              </select>
            </div>
          </div>
                  
          <!-- Return Period -->
          <div class="row">
            <div class="col-6">Return Period</div>
            <div class="col-6">
              <select name="returnperiod" v-model="returnPeriod">
                <option value="10">10 year</option>
                <option value="50">50 year</option>
              </select>
            </div>
          </div>
        </div>
                
        <!-- Custom Mode -->
        <div v-if="climate_method === 'user'">
          <div class="row">
            <div class="col-6">Reference Velocity Pressure, q</div>
            <div class="col-6">
              <input type="number" step="0.01" v-model.number="q_user" /> kPa
            </div>
          </div>
        </div>
            
        <!-- Section 2: Factors -->
        <!-- Importance Factor -->
        <div class="row">
          <div class="col-6">
            <label for="Iw">Importance Category:</label>
          </div>
          <div class="col-6">
            <select name="Iw_category" v-model="Iw_category">
              <option value="0">Low</option>
              <option value="1">Normal</option>
              <option value="2">High</option>
              <option value="3">Post Disaster</option>
            </select>
          </div>
        </div>
        <hr/>
                
        <!-- Exposure Factor -->
        <div class="row">
          <div class="col-6">
            <label for="Cw">Exposure Factor, C<sub>e</sub>:</label>
          </div>
        </div>
        <!-- Terrain -->
        <div class="row">
          <div class="col-6">
            <label for="exposure">Terrain</label>
          </div>
          <div class="col-6">
            <select name="exposure" v-model="exposure">
              <option value="open">Open terrain</option>
              <option value="rough">Rough terrain</option>
            </select>
          </div>
        </div>
                
        <!-- Reference Height for Ce -->
        <div class="row">
          <div class="col-6">
            <label for="height">Reference height for external pressure</label>
          </div>
          <div class="col-6">
            <input type="number" step="0.1" v-model.number="height" /> m
          </div>
        </div>
                
        <!-- Reference Height for Cei -->
        <div class="row">
          <div class="col-6">
            <label for="height_i">Reference height for internal pressure</label>
          </div>
          <div class="col-6">
            <input type="number" step="0.1" v-model.number="height_i" /> m
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-12">
            <p class="fst-italic comment">
              The exposure factor for internal pressures, C<sub>ei</sub>, shall be determined as follows: 
              a) for buildings whose height is greater than 20 m and that have a dominant opening, C<sub>ei</sub> shall be equal to the exposure factor for external pressures, C<sub>e</sub>, calculated at the mid-height of the dominant opening, and 
              b) for other buildings, C<sub>ei</sub> shall be the same as the exposure factor for external pressures, C<sub>e</sub>, calculated for a reference height, h, equal to the mid-height of the building or 6 m, whichever is greater.
            </p>
          </div>
        </div> -->
        <hr/>
        
        <!-- Ct -->
        <div class="row">
          <div class="col-6">
            <label for="ct">Topographic Factor, C<sub>t</sub>:</label>
          </div>
          <div class="col-6">
            <input type="number" step="0.01" v-model.number="ct" />
          </div>
        </div>
        <hr/>

        <!-- Cpcg Figure -->
        <div class="row">
          <div class="col-6">Pressure Coefficient and Gust Factor, C<sub>p</sub>C<sub>g</sub>:</div>
          <div class="col-6">
            <select v-model="cpcg_figure">
              <option value="A">Figure 4.1.7.6.-A Low buildings (H ≤ 20m)</option>
              <option value="B" disabled>Figure 4.1.7.6.-B Individual walls and wall cladding</option>
              <option value="C" disabled>Figure 4.1.7.6.-C Roofs with a slope ≤ 7°</option>
              <option value="D" disabled>Figure 4.1.7.6.-D Flat roofs with steps in elevation</option>
              <option value="E" disabled>Figure 4.1.7.6.-E Gabled or hipped, single-ridge roofs with slope > 7°</option>
              <option value="F" disabled>Figure 4.1.7.6.-F Gabled, multi-ridge roofs with slope > 10°</option>
              <option value="G" disabled>Figure 4.1.7.6.-G Monosloped roofs with slope > 3° and ≤ 30°</option>
              <option value="H" disabled>Figure 4.1.7.6.-H Sawtooth roofs with slope > 10°</option>
            </select>
          </div>
        </div>

        <!-- Roof Pitch -->
        <div class="row">
          <div class="col-6">
            <label for="pitch">Roof Pitch</label>
          </div>
          <div class="col-6">
            <input type="number" v-model.number="pitch" /> /12
          </div>
        </div>
        <hr/>

        <!-- Internal Pressure Category -->
        <div class="row">
          <div class="col-6">
            <label for="category">Internal Pressure Category</label>
          </div>
          <div class="col-6">
            <select name="category" v-model="cpi_category">
              <option value="1">Category 1: Cpi = -0.15 to 0</option>
              <option value="2">Category 2: Cpi = -0.45 to 0.3</option>
              <option value="3">Category 3: Cpi = -0.7 to 0.7</option>
            </select>
          </div>
        </div>

        <!-- Add this after the Internal Pressure Category select -->
        <div class="row" v-if="cpi_category === '1'">
          <div class="col-12">
            <p class="fst-italic comment">
              Uniformly distributed small openings amounting to less than 0.1% of the total surface area of the building
            </p>
          </div>
        </div>
        <div class="row" v-if="cpi_category === '2'">
          <div class="col-12">
            <p class="fst-fst-italic comment">
              Non-uniformly distributed openings of which none is significant or significant openings that are wind-resistant and closed during storms
            </p>
          </div>
        </div>
        <div class="row" v-if="cpi_category === '3'">
          <div class="col-12">
            <p class="fst-fst-italic comment">
              Large openings likely to remain open during storms
            </p>
          </div>
        </div>
      </div>
      
      <!-- Results Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <h4>Specified Wind Load</h4>
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'p = I_w q C_e C_t C_g C_p'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">[4.1.7.3]</p>
          </div>
        </div>
        
        <!-- Display q based on mode -->
        <div v-if="climate_method === 'user'">
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'q = ' + q.toFixed(2) + ' \\text{ kPa}'" />
            </div>
            <div class="col-6">
              <p class="fst-italic">User input</p>
            </div>
          </div>
        </div>
        <div v-if="climate_method === 'location'">
          <div class="row" v-if="q">
            <div class="col-6">
              <KaTeXComponent :expression="qLabel + ' = ' + q.toFixed(2) + ' \\text{ kPa}'" />
            </div>
            <div class="col-6">
              <p class="fst-italic" v-if="province">Province: {{ province }}</p>
            </div>
          </div>
          <div class="row" v-if="city">
            <div class="col-6"></div>
            <div class="col-6">
              <p class="fst-italic">City: {{ city }}</p>
            </div>
          </div>
        </div>
        
        <hr/>
        
        <h5>Factors:</h5>
        <!-- IS ULS -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'I_w = ' + Iw_ULS[Iw_category].toFixed(2) + ' \\text{ (ULS)}'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">{{ ["Low", "Normal", "High", "Post-Disaster"][Iw_category] }} importance category</p>
          </div>
        </div>
        <!-- IS SLS -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'I_w = ' + Iw_SLS[Iw_category].toFixed(2) + ' \\text{ (SLS)}'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">{{ ["Low", "Normal", "High", "Post-Disaster"][Iw_category] }} importance category</p>
          </div>
        </div>
        
        <!-- Ce -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'C_e = ' + ce.toFixed(2)" />
          </div>
          <div class="col-6">
            <p class="fst-italic">Height = {{ height }}m, {{ exposure }} terrain</p>
          </div>
        </div>
        
        <!-- Ct -->
        <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'C_t = ' + ct.toFixed(2)" />
          </div>
          <div class="col-6">
            <p class="fst-italic">Topographic factor</p>
          </div>
        </div>
        
        <!-- Cg -->
        <!-- <div class="row">
          <div class="col-6">
            <KaTeXComponent :expression="'C_{g} = 2.00'" />
          </div>
          <div class="col-6">
            <p class="fst-italic">Gust factor</p>
          </div>
        </div> -->
        <hr/>
        
        <div v-if="cpcg_figure === 'A'">
          <h4>External Wind Pressure</h4>
          <p class="fst-italic">Load Case A: Winds generally perpendicular to ridge<br>
          Load Case B: Winds generally parallel to ridge</p>
          
          <div class="table-responsive mt-3">
            <table class="wind-table">
              <thead>
                <tr>
                  <th rowspan="3" class="fst-italic">Side</th>
                  <th colspan="3" class="fst-italic">Load Case A</th>
                  <th colspan="3" class="fst-italic">Load Case B</th>
                </tr>
                <tr>
                  <th class="fst-italic">C<sub>p</sub>C<sub>g</sub></th>
                  <th class="fst-italic">ULS</th>
                  <th class="fst-italic">SLS</th>
                  <th class="fst-italic">C<sub>p</sub>C<sub>g</sub></th>
                  <th class="fst-italic">ULS</th>
                  <th class="fst-italic">SLS</th>
                </tr>
                <tr>
                  <th class="fst-italic"></th>
                  <th class="fst-italic">p (kPa)</th>
                  <th class="fst-italic">p (kPa)</th>
                  <th class="fst-italic"></th>
                  <th class="fst-italic">p (kPa)</th>
                  <th class="fst-italic">p (kPa)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="side in windPressureTable" :key="side.name">
                  <td class="fst-italic">{{ side.name }}</td>
                  <td class="fst-italic">{{ side.caseA.cpcg }}</td>
                  <td class="fst-italic">{{ side.caseA.uls }}</td>
                  <td class="fst-italic">{{ side.caseA.sls }}</td>
                  <td class="fst-italic">{{ side.caseB.cpcg }}</td>
                  <td class="fst-italic">{{ side.caseB.uls }}</td>
                  <td class="fst-italic">{{ side.caseB.sls }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        
          <hr/>
          
          <h4>Internal Wind Pressure</h4>
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'C_{gi} = 2.00'" />
            </div>
            <div class="col-6">
              <p class="fst-italic">Gust factor</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'C_{ei} = ' + cei.toFixed(2)" />
            </div>
            <div class="col-6">
              <p class="fst-italic">Height = {{ height_i }}m</p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'C_{pi} = ' + cpiValues.min + ' \\text{ to } ' + cpiValues.max" />
            </div>
            <div class="col-6">
              <p class="fst-italic" v-if="category === '1'">
                Uniformly distributed small openings amounting to less than 0.1% of the total surface area of the building
              </p>
              <p class="fst-italic" v-if="category === '2'">
                Non-uniformly distributed openings of which none is significant or significant openings that are wind-resistant and closed during storms
              </p>
              <p class="fst-italic" v-if="category === '3'">
                Large openings likely to remain open during storms
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'p_i = I_w q C_{ei} C_t C_{gi} C_{pi}'" />
            </div>
            <div class="col-6"></div>
          </div>
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'\\text{ULS: } p_i = ' + internalPressure.ulsMin + '\\text{ kPa to } ' + internalPressure.ulsMax + '\\text{ kPa}'" />
            </div>
            <div class="col-6"></div>
          </div>
          <div class="row">
            <div class="col-6">
              <KaTeXComponent :expression="'\\text{SLS: } p_i = ' + internalPressure.slsMin + '\\text{ kPa to } ' + internalPressure.slsMax + '\\text{ kPa}'" />
            </div>
            <div class="col-6"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopbarNav from "@/components/TopbarNav.vue";

import database from '@/assets/database.json';

export default {
  name: "WindLoadStaticLow",
  components: {
    TopbarNav: TopbarNav
  },
  data() {
    return {
      climate_method: "location", // Whether q is defined by user or by location
      province: "Ontario",
      city: "Toronto Metropolitan Region - Toronto (City Hall)",
      returnPeriod: "50", // Return period for location-based q (10 or 50 years)
      q_user: 1.0,
      Iw_category: "1", // Importance category index for Iw
      Iw_ULS: [0.8, 1, 1.15, 1.25],
      Iw_SLS: [0.75, 0.75, 0.75, 0.75],
      exposure: "open",
      height: 1.0,
      height_i: 1.0,
      pitch: 0,
      ct: 1.0,
      cpi_category: "1",
      cpcg_figure: "A",
    };
  },
  computed: {
    slope: function() {
      return (Math.atan(this.pitch/12)*(180/Math.PI));
    },
    sides() {
      // Figure 4.2.7.6.-A
      const rows = [
        { angle: 5, values: [0.75, 1.15, -1.3, -2.0, -0.7, -1.0, -0.55, -0.8] },
        { angle: 20, values: [1.0, 1.5, -1.3, -2.0, -0.9, -1.3, -0.8, -1.2] },
        { angle: 30, values: [1.05, 1.3, 0.4, 0.5, -0.8, -1.0, -0.7, -0.9] },
        { angle: 45, values: [1.05, 1.3, 0.4, 0.5, -0.8, -1.0, -0.7, -0.9] },
        { angle: 90, values: [1.05, 1.3, 1.05, 1.3, -0.7, -0.9, -0.7, -0.9] }
      ];

      let rowMultipliers;

      // Handle boundary cases
      if (this.slope <= 5) {
        rowMultipliers = rows[0].values;
      } else if (this.slope > 30 && this.slope <= 45) {
        // Fixed row 3 for 30-45 degrees (no interpolation)
        rowMultipliers = rows[2].values;
      } else if (this.slope >= 90) {
        rowMultipliers = rows[4].values;
      } else {
        // Find the two rows to interpolate between
        let lowerRow, upperRow;
        
        for (let i = 0; i < rows.length - 1; i++) {
          if (this.slope > rows[i].angle && this.slope <= rows[i + 1].angle) {
            lowerRow = rows[i];
            upperRow = rows[i + 1];
            break;
          }
        }

        // Linear interpolation
        const t = (this.slope - lowerRow.angle) / (upperRow.angle - lowerRow.angle);
        
        rowMultipliers = lowerRow.values.map((lowerValue, index) => {
          const upperValue = upperRow.values[index];
          return lowerValue + t * (upperValue - lowerValue);
        });
      }

      return [
        { name: '1', cpcgA: rowMultipliers[0], cpcgB: -0.85, isEnd: false },
        { name: '1E', cpcgA: rowMultipliers[1], cpcgB: -0.9, isEnd: true },
        { name: '2', cpcgA: rowMultipliers[2], cpcgB: -1.3, isEnd: false },
        { name: '2E', cpcgA: rowMultipliers[3], cpcgB: -2.0, isEnd: true },
        { name: '3', cpcgA: rowMultipliers[4], cpcgB: -0.7, isEnd: false },
        { name: '3E', cpcgA: rowMultipliers[5], cpcgB: -1.0, isEnd: true },
        { name: '4', cpcgA: rowMultipliers[6], cpcgB: -0.85, isEnd: false },
        { name: '4E', cpcgA: rowMultipliers[7], cpcgB: -0.9, isEnd: true },
        { name: '5', cpcgA: null, cpcgB: 0.75, isEnd: false },
        { name: '5E', cpcgA: null, cpcgB: 1.15, isEnd: true },
        { name: '6', cpcgA: null, cpcgB: -0.55, isEnd: false },
        { name: '6E', cpcgA: null, cpcgB: -0.8, isEnd: true }
      ];
    },
    cities: function() {
      return database.filter(item => item.province === this.province);
    },
    categoryLabel() {
      const labels = {
        "1": "Category 1",
        "2": "Category 2",
        "3": "Category 3"
      };
      return labels[this.cpi_category];
    },
    q10: function() {
      return this.city ? this.cities.filter(city => city.city === this.city)[0]["q(1/10) (kPa)"] : undefined;
    },
    q50: function() {
      return this.city ? this.cities.filter(city => city.city === this.city)[0]["q(1/50) (kPa)"] : undefined;
    },
    q() {
      if (this.climate_method === 'user') {
        return this.q_user;
      }
      // Location-based q value 
      return this.returnPeriod === "50" ? parseFloat(this.q50) : parseFloat(this.q10);
    },
    qLabel() {
      if (this.returnPeriod === "10") {
        return "q(1/10)";
      } else {
        return "q(1/50)";
      }
    },
    ce() {
      return this.calculateCe(this.height);
    },
    cei() {
      return this.calculateCe(this.height_i);
    },
    cpiValues() {
      const values = {
        "1": { min: -0.15, max: 0 },
        "2": { min: -0.45, max: 0.3 },
        "3": { min: -0.7, max: 0.7 }
      };
      return values[this.cpi_category];
    },
    windPressureTable() {
      const Iw_SLS = this.Iw_SLS[this.Iw_category];
      const Iw_ULS = this.Iw_ULS[this.Iw_category];
      const q = this.q;
      const ce = this.ce;
      const ct = this.ct;
      
      return this.sides.map(side => ({
        name: side.name,
        isEnd: side.isEnd,
        caseA: {
          cpcg: side.cpcgA !== null ? side.cpcgA.toFixed(2) : 'n/a',
          uls: side.cpcgA !== null ? (Iw_ULS * q * ce * ct * side.cpcgA).toFixed(2) : 'n/a',
          sls: side.cpcgA !== null ? (Iw_SLS * q * ce * ct * side.cpcgA).toFixed(2) : 'n/a'
        },
        caseB: {
          cpcg: side.cpcgB !== null ? side.cpcgB.toFixed(2) : 'n/a',
          uls: side.cpcgB !== null ? (Iw_ULS * q * ce * ct * side.cpcgB).toFixed(2) : 'n/a',
          sls: side.cpcgB !== null ? (Iw_SLS * q * ce * ct * side.cpcgB).toFixed(2) : 'n/a'
        }
      }));
    },
    internalPressure() {
      const Iw_SLS = this.Iw_SLS[this.Iw_category];
      const Iw_ULS = this.Iw_ULS[this.Iw_category];
      const q = this.q;
      const cei = this.cei;
      const ct = this.ct;
      const cgi = 2;
      
      return {
        ulsMin: (Iw_ULS * q * cei * ct * cgi * this.cpiValues.min).toFixed(2),
        ulsMax: (Iw_ULS * q * cei * ct * cgi * this.cpiValues.max).toFixed(2),
        slsMin: (Iw_SLS * q * cei * ct * cgi * this.cpiValues.min).toFixed(2),
        slsMax: (Iw_SLS * q * cei * ct * cgi * this.cpiValues.max).toFixed(2)
      };
    },
  },
  watch: {
    province: function(newProvince) {
      if (newProvince && this.cities.length > 0) {
        this.city = this.cities[0].city;
      }
    }
  },
  methods: {
    calculateCe(h) {
      let ce;
      if (this.exposure === 'open') {
        // Open terrain
        ce = Math.pow(h / 10, 0.2);
        ce = Math.max(ce, 0.9);
      } else {
        // Rough terrain
        ce = 0.7 * Math.pow(h / 12, 0.3);
        ce = Math.max(ce, 0.7);
      }
      return ce;
    }
  }
};
</script>

<style scoped>
.wind-table {
  font-size: 0.7rem;
  border-collapse: collapse;
  width: 100%;
  margin-top: 10px;
  background-color: #fff;
}

.wind-table th, .wind-table td {
  text-align: center;
  vertical-align: middle;
  padding: 2px 4px;
  border: 1px solid #999;
  background-color: #fff !important;
  min-width: 35px;
}

.wind-table th {
  font-weight: bold;
  background-color: #fff !important;
}

.wind-table td {
  font-weight: normal;
  background-color: #fff !important;
}

.results {
  font-size: 0.85rem;
  line-height: 1.6;
}
</style>